import { render, staticRenderFns } from "./EditBankaccount.vue?vue&type=template&id=1a7ed515&"
import script from "./EditBankaccount.vue?vue&type=script&lang=js&"
export * from "./EditBankaccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports